var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'widget-wrapper': true,
    'widget-wrapper-with-margins': !_vm.isPresentation,
  }},[_c('div',{ref:"frameNode",staticClass:"widget-target"})])
}
var staticRenderFns = []

export { render, staticRenderFns }